import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {RequirementsEditor} from '../../components/VisaRequirements';
import CurrencySelect from '../../components/CurrencySelect';
import { useAuth } from '../../context/AuthContext';
const labels = {
  id: "المعرف",
  name: "الاسم",
  value: "القيمة",
  type: "النوع",
  code: "الرمز",
  name_ar: "الاسم بالعربية",
  name_en: "الاسم بالإنجليزية",
  country: "الدولة",
  city: "المدينة",
  status: "الحالة",
  price: "السعر",
  currency: "العملة",
  full_name: "الاسم الكامل",
  email: "البريد",
  phone: "الهاتف",
  role: "الصلاحية",
  is_active: "نشط",
  created_at: "تاريخ الإنشاء",
  password: "كلمة المرور",
  company_id: "معرف الشركة",
  company_name: "الشركة",
  from_city: "مدينة المغادرة",
  to_city: "مدينة الوصول",
  departure_time: "موعد المغادرة",
  arrival_time: "موعد الوصول",
  duration: "المدة",
  bus_type: "نوع الحافلة",
  seats_total: "عدد المقاعد",
  seats_available: "المقاعد المتاحة",
  airline_ar: "شركة الطيران بالعربية",
  airline_en: "شركة الطيران بالإنجليزية",
  airline_code: "رمز الشركة",
  from_airport: "مطار المغادرة",
  from_code: "رمز المغادرة",
  to_airport: "مطار الوصول",
  to_code: "رمز الوصول",
  stops: "التوقفات",
  economy_price: "السعر الاقتصادي",
  business_price: "سعر الأعمال",
  first_class_price: "سعر الدرجة الأولى",
  contact_phone: "هاتف الشركة",
  contact_email: "بريد الشركة",
  user_id: "العميل",
  booking_id: "الحجز",
  booking_type: "نوع الحجز",
  from_location: "من",
  to_location: "إلى",
  departure_date: "تاريخ المغادرة",
  return_date: "تاريخ العودة",
  passengers: "المسافرون",
  total_amount: "الإجمالي",
  amount: "المبلغ",
  payment_method: "طريقة الدفع",
  description: "الوصف",
  entry_number: "رقم القيد",
  entry_date: "تاريخ القيد",
  is_posted: "مرحّل",
  invoice_number: "رقم الفاتورة",
  customer_name: "العميل",
  total: "الإجمالي",
  issue_date: "تاريخ الإصدار",
  due_date: "الاستحقاق",
  voucher_number: "رقم السند",
  voucher_date: "تاريخ السند",
  transactions_count: "عدد العمليات",
  balance: "الرصيد",
  account_type: "نوع الحساب",
  parent_id: "الحساب الأب"
};
const titles = {
  countries: "الدول",
  cities: "المدن",
  airports: "المطارات",
  buses: "الحافلات",
  flights: "تذاكر الطيران",
  shipping: "شركات النقل والشحن",
  users: "المستخدمون",
  bookings: "الحجوزات",
  payments: "المدفوعات",
  journal: "القيود اليومية",
  invoices: "الفواتير",
  receipts: "سندات القبض",
  'payment-vouchers': "سندات الصرف",
  reports: "تقارير المدفوعات حسب العملة والحالة"
};
const fields = {
  countries: ['name', 'name_en', 'value', 'type'],
  cities: ['name', 'name_en', 'code', 'type'],
  airports: ['name', 'name_en', 'code'],
  users: ['full_name', 'email', 'phone', 'role', 'is_active', 'password'],
  shipping: ['name_ar', 'name_en', 'code', 'contact_phone', 'contact_email', 'is_active'],
  buses: ['company_id', 'company_name', 'from_city', 'to_city', 'departure_time', 'arrival_time', 'duration', 'bus_type', 'seats_total', 'seats_available', 'price', 'currency', 'status'],
  flights: ['airline_ar', 'airline_en', 'airline_code', 'from_city', 'from_airport', 'from_code', 'to_city', 'to_airport', 'to_code', 'departure_time', 'arrival_time', 'duration', 'stops', 'economy_price', 'business_price', 'first_class_price', 'currency', 'seats_available', 'status']
};
const required = new Set(['name', 'value', 'type', 'code', 'name_ar', 'name_en', 'full_name', 'email', 'role', 'company_id', 'from_city', 'to_city', 'departure_time', 'arrival_time', 'airline_ar', 'airline_en']);
const numeric = new Set(['price', 'seats_total', 'seats_available', 'stops', 'economy_price', 'business_price', 'first_class_price']);
const optionLabels = {
  country: "دولة للفنادق",
  visa: "دولة للتأشيرات",
  departure: "مدينة مغادرة",
  arrival: "مدينة وصول",
  hotel: "مدينة فنادق",
  admin: "مدير",
  staff: "موظف",
  customer: "عميل",
  active: "نشط",
  inactive: "غير نشط",
  pending: "قيد الانتظار",
  '1': "نعم",
  '0': "لا"
};
export default function RecordsPage({
  resource
}) {
  __useLocale();
  const {
    token,
    isAdmin
  } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [reload, setReload] = useState(0);
  const [query, setQuery] = useState('');
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError('');
    setRows([]);
    setForm(null);
    setQuery('');
    axios.get('/api/records.php', {
      params: {
        resource
      },
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: controller.signal
    }).then(res => {
      if (!Array.isArray(res.data)) throw new Error();
      if (!controller.signal.aborted) setRows(res.data);
    }).catch(e => {
      if (!controller.signal.aborted) setError(e.response?.data?.message || "تعذر تحميل القائمة");
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    if (resource === 'buses') axios.get('/api/records.php?resource=shipping', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: controller.signal
    }).then(res => setCompanies(res.data)).catch(() => {});
    return () => controller.abort();
  }, [resource, token, reload]);
  const save = async e => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await axios({
        method: form.id ? 'put' : 'post',
        url: '/api/records.php',
        params: {
          resource,
          id: form.id
        },
        data: ['flights','buses'].includes(resource)?{...form,requirements_json:JSON.stringify(form.requirements||[])}:form,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setForm(null);
      setReload(n => n + 1);
    } catch (e) {
      setError(e.response?.data?.message || "تعذر الحفظ");
    } finally {
      setSaving(false);
    }
  };
  const remove = async row => {
    if (!window.confirm(__tr("هل تريد حذف هذا السجل؟"))) return;
    setSaving(true);
    setError('');
    try {
      await axios.delete('/api/records.php', {
        params: {
          resource,
          id: row.id
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setReload(n => n + 1);
    } catch (e) {
      setError(e.response?.data?.message || "تعذر الحذف؛ قد يكون السجل مرتبطًا ببيانات أخرى");
    } finally {
      setSaving(false);
    }
  };
  const editable = isAdmin && fields[resource];
  const editorFields = fields[resource] || [];
  const columns = rows.length ? Object.keys(rows[0]).filter(k=>k!=='requirements_json') : [];
  const filtered = rows.filter(row => Object.values(row).some(v => String(v ?? '').toLowerCase().includes(query.toLowerCase())));
  return <section className="bg-white rounded-xl shadow p-6 space-y-4" dir={__direction()}>
    <div className="flex flex-wrap justify-between gap-3"><h2 className="text-xl font-bold">{__tr(titles[resource] || resource)}</h2>
      <div className="flex gap-2"><button className="border rounded px-3 py-2" onClick={() => setReload(n => n + 1)}>{__tr("تحديث")}</button>{__tr(editable && <button className="bg-[#6B5B95] text-white rounded px-4 py-2" onClick={() => setForm({
          currency: '',
          status: 'active',
          is_active: '1',
          role: 'customer',
          type: resource === 'cities' ? 'hotel' : 'country',
          seats_total: 40,
          seats_available: 40
        })}>{__tr("إضافة")}</button>)}</div>
    </div>
    {__tr(error && <p role="alert" className="text-red-700">{__tr(error)}</p>)}
    {__tr(form && <form onSubmit={save} className="border rounded-xl p-4 space-y-4"><div className="grid md:grid-cols-2 gap-4">
      {__tr(editorFields.map(field => {
          const choices = field === 'type' ? resource === 'cities' ? ['departure', 'arrival', 'hotel'] : ['country', 'visa'] : field === 'role' ? ['admin', 'staff', 'customer'] : field === 'status' ? ['active', 'inactive', 'pending'] : field === 'is_active' ? ['1', '0'] : null;
          const inputType = field.includes('_time') ? 'datetime-local' : field.includes('email') ? 'email' : field === 'password' ? 'password' : numeric.has(field) ? 'number' : 'text';
          return <label key={field} className="text-sm space-y-1"><span>{__tr(labels[field] || field)}</span>
          {__tr(field === 'currency' ? <CurrencySelect required value={form.currency} onChange={e => setForm({
              ...form,
              currency: e.target.value
            })} /> : field === 'company_id' ? <select required className="block border rounded p-2 w-full" value={form[field] || ''} onChange={e => setForm({
              ...form,
              company_id: e.target.value,
              company_name: companies.find(c => String(c.id) === e.target.value)?.name_ar || ''
            })}><option value="">{__tr("اختر الشركة")}</option>{__tr(companies.map(c => <option key={c.id} value={c.id}>{__tr(__localizedField(c, "name_ar"))}</option>))}</select> : choices ? <select className="block border rounded p-2 w-full" value={String(form[field] ?? '')} required onChange={e => setForm({
              ...form,
              [field]: e.target.value
            })}><option value="">{__tr("اختر")}</option>{__tr(choices.map(v => <option key={v} value={v}>{__tr(optionLabels[v])}</option>))}</select> : <input className="block border rounded p-2 w-full" type={inputType} min={numeric.has(field) ? 0 : undefined} step={numeric.has(field) ? 'any' : undefined} minLength={field === 'password' ? 8 : undefined} required={field === 'password' ? !form.id : required.has(field)} value={inputType === 'datetime-local' ? (form[field] || '').replace(' ', 'T').slice(0, 16) : form[field] ?? ''} onChange={e => setForm({
              ...form,
              [field]: e.target.value
            })} />)}
        </label>;
        }))}
    </div>{['flights','buses'].includes(resource)&&<RequirementsEditor serviceType={resource==='flights'?'flight':'bus'} value={form.requirements||[]} onChange={requirements=>setForm({...form,requirements})}/>}<button disabled={saving} className="bg-[#6B5B95] text-white rounded px-4 py-2">{__tr(saving ? "جارٍ الحفظ…" : "حفظ")}</button> <button type="button" disabled={saving} onClick={() => setForm(null)}>{__tr("إلغاء")}</button></form>)}
    <input aria-label={__tr("بحث في القائمة")} placeholder={__tr("بحث في القائمة")} value={query} onChange={e => setQuery(e.target.value)} className="border rounded p-2 w-full" />
    {__tr(loading ? <p role="status">{__tr("جارٍ التحميل…")}</p> : !error && !filtered.length ? <p role="status">{__tr("لا توجد بيانات.")}</p> : <div className="overflow-x-auto"><table className="w-full text-sm"><thead><tr>{__tr(columns.map(c => <th className="text-right border-b p-3 whitespace-nowrap" key={c}>{__tr(__localizedField(labels, c) || c)}</th>))}{__tr(editable && <th>{__tr("الإجراءات")}</th>)}</tr></thead><tbody>{__tr(filtered.map((row, index) => <tr key={row.id ?? index}>{__tr(columns.map(c => <td key={c} className="border-b p-3">{__tr(String(__localizedField(row, c) ?? '—'))}</td>))}{__tr(editable && <td className="p-3 whitespace-nowrap"><button className="text-purple-700 ml-3" disabled={saving} onClick={() => setForm({
                ...row,
                requirements:JSON.parse(row.requirements_json||'[]'),
                password: ''
              })}>{__tr("تعديل")}</button>{__tr(resource !== 'users' && <button className="text-red-700" disabled={saving} onClick={() => remove(row)}>{__tr("حذف")}</button>)}</td>)}</tr>))}</tbody></table></div>)}
  </section>;
}
